import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import vuetify from '@/plugins/vuetify';
import { auth0Config } from '@/config';
import Auth from '@/plugins/auth';
import store from '@/store';
import App from '@/App.vue';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'mapbox-gl-controls/lib/controls.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import './registerServiceWorker';

Vue.use(Auth, auth0Config);
Vue.component('apexchart', VueApexCharts);

const { NODE_ENV: env } = process.env;
Vue.config.debug = env !== 'production';
Vue.config.devtools = env !== 'production';
Vue.config.productionTip = env !== 'production';

new Vue({
  vuetify,
  store,
  render: (h) => h(App)
}).$mount('#app');
